import SimpleTableItem from '@/models/general/simpleTableItem'
import i18n from '@plugins/vue-i18n'

/**
 * @property {string} date - date in friendly format
 * @property {string} bookingId - booking Id
 * @property {string} name - educator name (candidate)
 * @property {string} time - duration of the shift
 * @property {string} action - action text based on whether filled or unfilled
 * @property {Integer} candidateId - candidate Id (used internally)
 */
export default class ExtendBookingConfirmationItem extends SimpleTableItem {
  constructor(bookingId, candidate, date, time) {
    super()
    this.date = date
    this.bookingId = bookingId
    this.candidateId = candidate?.id
    this.name = candidate?.id
      ? candidate.name
      : i18n.t('booking.extend.unfilled')
    this.time = time
    this.action = candidate?.id
      ? i18n.t('booking.extend.filledActionText')
      : i18n.t('booking.extend.unfilledActionText')
  }
}
